import React from 'react';

import './ResetPasswordPage.css';
import ResetPasswordForm from './components/ResetPasswordForm';

const ResetPasswordPage: React.FC = () => {
    document.title = 'Reset Password';

    return (
        <div className="reset-password-bg">
            <div className="reset-password-box">
                <h1>Reset Your Password</h1>
                <p>Please enter a new password below.</p>
                <br />
                <ResetPasswordForm />
            </div>
        </div>
    );
};

export default ResetPasswordPage;
